import {Location} from 'history';
import * as React from 'react';
import {connect, MapStateToProps} from 'react-redux';
import {match, RouteComponentProps} from 'react-router';
import {Redirect, Route, Switch} from 'react-router-dom';

import {PredictiveModelViewerSpaceProvider} from '~src/predictiveModel/components/PredictiveModelViewerSpaceProvider';
import {SpacesSiteUrls} from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { PredictiveModelSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import {SessionSiteSelectors} from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import {AppState} from '../../bootstrap/redux/state/AppState';
import {RouterError} from '../../bootstrap/routerHelpers/RouterError';

export interface PredictiveModelRouteParams {
  readonly id: string;
}

export interface PredictiveModelRouteComponentProps extends RouteComponentProps<PredictiveModelRouteParams> {
  readonly match: match<PredictiveModelRouteParams>;
  readonly location: Location;
}

export interface PredictiveModelSpaceRouterOwnProps {
  readonly siteName: string;
  readonly previousUrl: string;
  readonly urls: SpacesSiteUrls;
}

export interface PredictiveModelSpaceRouterStateProps {
  readonly isRequestAccessEnabled: boolean;
  readonly catalogingOnSiteEnabled: boolean;
}

export type PredictiveModelSpaceRouterProps =
  PredictiveModelRouteComponentProps &
  PredictiveModelSpaceRouterOwnProps &
  PredictiveModelSpaceRouterStateProps;

export class PredictiveModelSpaceRouterComponent extends React.Component<PredictiveModelSpaceRouterProps, {}> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.predictiveModelPath(':id')} render={(routeProps: PredictiveModelRouteComponentProps) =>
          <Redirect to={this.props.urls.predictiveModelOverviewPath(routeProps.match.params.id)} />
        } />
        <Route exact path={this.props.urls.predictiveModelOverviewPath(':id')} render={this.spaceProviderFor('overview')} />
        <Route exact path={this.props.urls.predictiveModelConnectionsPath(':id')} render={this.spaceProviderFor('connections')} />
        <Route exact path={this.props.urls.predictiveModelConnectedContentPath(':id')} render={this.spaceProviderFor('connectedContent')} />
        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls} />} />
      </Switch>
    );
  }

  private spaceProviderFor = (subspace: PredictiveModelSubspaceName): (routeProps: PredictiveModelRouteComponentProps) => JSX.Element => {
    return (routeProps: PredictiveModelRouteComponentProps) => {
      return <PredictiveModelViewerSpaceProvider
        routeLocationSearch={routeProps.location.search}
        routeLocationPath={routeProps.location.pathname}
        siteName={this.props.siteName}
        predictiveModelIdOrLuid={routeProps.match.params.id}
        siteUrls={this.props.urls}
        subspaceName={subspace}
        isRequestAccessEnabled={this.props.isRequestAccessEnabled}
      />;
    };
  };
}

const mapStateToProps: MapStateToProps<PredictiveModelSpaceRouterStateProps, PredictiveModelSpaceRouterOwnProps, {}> = (state: AppState) => ({
  isRequestAccessEnabled: SessionSiteSelectors.isRequestAccessEnabled(state),
  catalogingOnSiteEnabled: SessionSiteSelectors.catalogingOnSiteEnabled(state)
});

export const PredictiveModelSpaceRouter: React.ComponentClass<PredictiveModelSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, { pure: false })(PredictiveModelSpaceRouterComponent);